/* divin-popup.js : declencheur, frequence et fermeture de sections/divin-popup.liquid
   NATIVE: popup.js ouvre un <dialog> en showModal(), qui piege le focus et consomme le premier
   clic : ici ni scroll-lock ni backdrop, la page reste utilisable
   IntersectionObserver et pas un ecouteur de scroll, comme divin-header.js
   la valeur stockee porte le nombre d'heures : changer le reglage repart d'une ardoise propre */
(function () {
  var KEY = "divin-popup-closed";

  function marker(top) {
    var el = document.createElement("div");
    el.setAttribute("aria-hidden", "true");
    el.style.cssText =
      "position:absolute;top:" + top + "px;left:0;width:1px;height:1px;pointer-events:none;visibility:hidden;";
    document.body.prepend(el);
    return el;
  }

  function isMuted(hours) {
    /* repeat_hours 0 sort ici, avant le test === 0 plus bas : l'option "Jamais, une seule fois"
       rouvre la popup a chaque page */
    if (!hours) return false;
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      var saved = JSON.parse(raw);
      if (saved.hours !== hours) return false;
      if (hours === 0) return true;
      return Date.now() - saved.at < hours * 3600000;
    } catch (e) {
      return false;
    }
  }

  function mute(hours) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), hours: hours }));
    } catch (e) {
      /* navigation privee ou stockage refuse : la popup se rouvrira, sans casser */
    }
  }

  function init() {
    var root = document.querySelector("[data-divin-popup]");
    if (!root) return;

    var hours = parseInt(root.dataset.repeat, 10);
    var offset = parseInt(root.dataset.scroll, 10) || 700;

    function close() {
      root.classList.remove("is-open");
      mute(hours);
      /* delai cale a peu pres sur la transition de sortie, sinon elle saute ; hidden tombe un peu avant sa fin */
      window.setTimeout(function () {
        root.hidden = true;
      }, 300);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("click", onOutside, true);
    }

    function onKey(event) {
      if (event.key === "Escape") close();
    }

    function onOutside(event) {
      if (!root.contains(event.target)) close();
    }

    function open() {
      if (isMuted(hours)) return;
      root.hidden = false;
      /* deux frames : le navigateur doit avoir peint l etat ferme pour animer vers l ouvert */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add("is-open");
        });
      });
      document.addEventListener("keydown", onKey);
      /* capture: un clic sur une carte produit ferme la popup sans etre annule */
      document.addEventListener("click", onOutside, true);
    }

    root.querySelectorAll("[data-divin-popup-close]").forEach(function (btn) {
      btn.addEventListener("click", close);
    });

    if (isMuted(hours)) return;

    new IntersectionObserver(function (entries, observer) {
      if (entries[0].isIntersecting) return;
      open();
      observer.disconnect();
    }).observe(marker(offset));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
